import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { ReportFormDialogComponent } from './report-form/report-form.component';
import { Report, ReportParams } from './reports.model';
import { ReportsService } from './reports.service';

@Component({
  selector: 'reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {
    horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

    @Input('category')
    category: string;

    @Input('projectId')
    projectId: number;

    @Input('buttonTitle')
    buttonTitle: string;

    @Input('tooltip')
    tooltip: string;

    @Input('selected')
    selected: string;

    reports: Report[];
    dialogRef: any;
    reportParam: ReportParams;

    constructor(
        private _matDialog: MatDialog,
        private _matSnackBar: MatSnackBar,
        private _reportService: ReportsService) { }

  ngOnInit(): void {
      this._reportService.getReports(this.category).subscribe(
          resp => {
              this.reports = resp;
          }
      );
  }

  openDialog(): void{
        this.reportParam = new ReportParams();  
        this.reportParam.category = this.category;
        this.reportParam.projectId = this.projectId;
        const date = new Date();
        const firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1);
        const lastDay = new Date(date.getFullYear(), date.getMonth(), 0);
        this.reportParam.from = firstDay.toISOString().slice(0, 10);
        this.reportParam.to = lastDay.toISOString().slice(0, 10);
        this.reportParam.selected = this.selected;
        
        this.dialogRef = this._matDialog.open(ReportFormDialogComponent, {
            panelClass: 'report-form-dialog',
            data      : {
                action: 'new',
                reports: this.reports,
                params: this.reportParam
            }
        });

        this.dialogRef.afterClosed()
        .subscribe((response: FormGroup) => {
            if ( !response )
            {
                return;
            }
            const params: ReportParams = response.getRawValue();
            if (params.selected) {
                params.selected = this.selected;
            } else {
                params.selected = null;
            }
            params.projectId = this.projectId;
            params.category = this.category;
            this._matSnackBar.open('Generando reporte....', '',  {
                duration: 900000,
                horizontalPosition: this.horizontalPosition,
                verticalPosition: this.verticalPosition
              });
            this._reportService.generateReports(params).subscribe(
                resp => {
                    this._matSnackBar.open('Pronto!', 'Descargar',  {
                        duration: 600000,
                        horizontalPosition: 'end',
                        verticalPosition: 'top'
                    }).onAction().subscribe(() => {
                        let name: string = params.template.name;
                        if (resp != null )
                        {
                            name = resp.toString();
                        }
                        if (name.includes('.jasper')) {
                            name = name.replace('.jasper', '.pdf');
                        }
                        window.open('/ypm/reports/' + name);
                    });
                },
                error => {
                    this._matSnackBar.open('Hubo un error generando "' + params.template.name + '"', 'Cerrar', {
                        duration: 60000,
                        horizontalPosition: 'end',
                        verticalPosition: 'top',
                      });
                }
            );
        });
  }

}
